export default function jumpFocus() {
  const inputs = $('.js-jump-focus input');
  inputs.on('keyup', function () {
    const maxInputLength = $(this).data('max-length') ? $(this).data('max-length') : this.maxLength;
    if (this.value.length >= maxInputLength) {
      $(this).val(this.value.substr(0, maxInputLength));
      $(this).next('input').focus();
    }
  });

  inputs.on('focus', function () {
    $(this).select();
  });

  inputs.on('keydown', function (event) {
    const key = event.keyCode || event.charCode;
    if (key === 8 && !this.value.length) {
      $(this).prev('input').focus();
    }
  });

  inputs.on('paste', function () {
    const max = this.maxLength ? this.maxLength : 1;
    this.maxLength = 128;
    setTimeout(() => {
      const val = $(this).val();
      $(this).val(val.substr(0, max)).trigger('change');

      if (val.length > max) {
        $(this).next('input').val(val.substr(max)).trigger('paste')
          .focus();
      }
      this.maxLength = max;
    }, 10);
  });

  $('[data-paste]').each(function () {
    const paste = $(this).data('paste');
    if (paste) {
      const input = $(this).find('input').eq(0);
      input.val(paste).trigger('paste').focus();
    }
  });


  const logininputs = $('.js-jump-focus-login input');
  logininputs.on('keyup', function () {
    const maxInputLength = $(this).data('max-length') ? $(this).data('max-length') : this.maxLength;
    if (this.value.length >= maxInputLength) {
      $(this).val(this.value.substr(0, maxInputLength));
      $('#login-character-'+$(this).data('character-next')).focus();
    }
  });

  logininputs.on('focus', function () {
    $(this).select();
  });

  logininputs.on('keydown', function (event) {
    const key = event.keyCode || event.charCode;
    if (key === 8 && !this.value.length) {
      $('#login-character-'+$(this).data('character-prev')).focus();
    }
  });

}
